import { styled } from 'styled-system/jsx'

const Pill = styled('div', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    paddingX: '12px',
    paddingY: '6px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '700',
    color: '#FFFFFF',
    background:
      'linear-gradient(135deg, {colors.quickpass.warmth} 0%, {colors.quickpass.celebration} 100%)',
    boxShadow: '0 8px 18px -10px rgba(255, 139, 115, 0.6)',
  },
})

const Glyph = styled('span', {
  base: {
    fontSize: '14px',
    lineHeight: '1',
  },
})

const Hint = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '600',
    opacity: '0.85',
  },
})

export { Pill, Glyph, Hint }
